<template>
  <div class="col-lg-6 col-7">
    <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
      <ol class="breadcrumb breadcrumb-links">
        <li v-for="(breadcrumb, index) in routerBreadcrumbs"
            :key="index"
            v-if="header !== $t(breadcrumb.text)"
            class="breadcrumb-item"
            aria-current="page"
            v-bind:class="{active: breadcrumb.active}">
          <router-link :to="breadcrumb.link || '#' ">
            <i v-if="breadcrumb.icon" :class="breadcrumb.icon"></i>
            <span v-if="breadcrumb.text">
              {{ $t(breadcrumb.text) }}
            </span>
            <span v-else-if="breadcrumb.dynText">
              {{ breadcrumb.dynText($route.params) }}
            </span>
          </router-link>
        </li>
        <li
          class="breadcrumb-item active"
          aria-current="page">
          <span v-text="header"></span>
        </li>
      </ol>
    </nav>
  </div>
</template>
<script>
  import {_} from 'vue-underscore';

  export default {
    props: {
      header: {
        type: String,
        default: "Page header",
        description: ""
      },
      items: {
        type: Array,
        default: () => Array()
      }
    },
    computed: {
      routerBreadcrumbs() {
        return _.filter(
          _.map(this.$route.matched,
            route => {
              return route.meta && route.meta.breadcrumb
            }), value => !!value
        )
      }
    }
  };
</script>
<style></style>
